import React from "react";

const VideoModalLoader = () => {
    return (
        <div style={{
        width: '100%',
        height: '100%',
        background: 'rgba(0, 1, 4, 0.4)', // Dark background
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999,
        }}>
        <div style={{
            width: '120px',
            height: '120px',
            position: 'relative',
            borderRadius: '10px',
            backgroundColor: 'rgb(6, 36, 65)',
            border: '8px solid #333',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 10px 15px rgba(0, 0, 0, 0.3)',
        }}>
            <div style={{
            width: '60px',
            height: '60px',
            border: '8px solid #333',
            borderTop: '8px solid #1e90ff',
            borderRadius: '50%',
            animation: 'spin 1.5s linear infinite',
            position: 'absolute',
            }}></div>
            <div style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            border: '5px solid #333',
            borderRadius: '50%',
            borderTop: '5px solid #ff6347',
            animation: 'cameraRoll 2s ease-in-out infinite',
            }}></div>
        </div>
        <p style={{
            color: '#fff',
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            fontSize: '18px',
            marginTop: '20px',
            textAlign: 'center',
        }}>
            Loading Artifacts of Infraction !
        </p>

        <style>{`
            @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
            }

            @keyframes cameraRoll {
            0% { transform: rotate(0deg); }
            50% { transform: rotate(180deg); }
            100% { transform: rotate(360deg); }
            }
        `}</style>
        </div>
    );
}

export default VideoModalLoader;